import { makeAutoObservable } from "mobx";
import { BaseSearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import moment from "moment";
import { deleteAbstractProductService, getAbstractProductServiceById, pagingAbstractProductService, saveOrUpdateAbstractProductService, synchronizeAbstractProductService } from "app/services/AbstractProductService";
import { AbstractProductType } from "app/common/Model/AbstractProductType";
export default class AbstractProductStore {
    openAbstractProductCreateOrUpdate = false;
    searchAbstractProduct = new BaseSearchObject();
    pageAbstractProduct = null;
    selectedAbstractProduct = new AbstractProductType();
    openConfirmDeleteAbstractProduct = false;
    selectedRowAbstractProduct = null;
    constructor() {
        makeAutoObservable(this);
    }

    setSelectedRowAbstractProduct = (row) => {
        this.selectedRowAbstractProduct = row;
    };

    pagingAbstractProduct = async () => {
        return await pagingAbstractProductService(this.searchAbstractProduct)
            .then(({ data }) => {
                // console.log("Dữ liệu gửi đi:", data);
                this.pageAbstractProduct = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu nhóm sản phẩm có lỗi");
            });
    };

    handleOpenFormCreateOrEdit = (AbstractProductId) => {
        if (AbstractProductId) {
            getAbstractProductServiceById(AbstractProductId)
                .then(({ data }) => {
                    // console.log("DATA từ server:", data);
                    this.selectedAbstractProduct = data;
                    this.openAbstractProductCreateOrUpdate = true;
                })
                .catch((error) => {
                    toast.error("Lấy dữ liệu nhóm sản phẩm có lỗi");
                    console.error("Lỗi lấy dữ liệu nhóm sản phẩm:", error);
                });
        } else {
            this.selectedAbstractProduct = new AbstractProductType();
            this.openAbstractProductCreateOrUpdate = true;
        }
    };
    handleClosePopup = () => {
        this.openAbstractProductCreateOrUpdate = false;
        this.openConfirmDeleteAbstractProduct = false;
    };
    handleCreateOrEdit = async (AbstractProductData) => {
        try {
            // console.log("Dữ liệu gửi đi:", AbstractProductData);
            const { data } = await saveOrUpdateAbstractProductService(AbstractProductData);
            toast.success("Lưu Nhóm sản phẩm thành công!");
            this.handleClosePopup();
            await this.pagingAbstractProduct();
            return data;
        } catch (error) {
            toast.error("Lưu Nhóm sản phẩm thất bại!");
            console.error("Lưu Nhóm sản phẩm thất bại!:", error);
        }
    };
    handleDeleteAbstractProduct = (AbstractProduct) => {
        this.selectedAbstractProduct = AbstractProduct;
        this.openConfirmDeleteAbstractProduct = true;
    };

    handleDelete = async () => {
        const AbstractProductId = this.selectedAbstractProduct?.id;
        if (!AbstractProductId) return;

        deleteAbstractProductService(AbstractProductId)
            .then(() => {

                if (
                    this.searchAbstractProduct?.pageIndex > 1 &&
                    this.pageAbstractProduct?.content?.length === 1
                ) {
                    this.searchAbstractProduct.pageIndex -= 1;
                }
                toast.success("Xóa nhóm sản phẩm thành công!");
                this.pagingAbstractProduct();
                this.handleClosePopup();
            })
            .catch((error) => {
                console.error("Lỗi khi xóa nhóm sản phẩm:", error);
                toast.error("Xóa nhóm sản phẩm thất bại!");
            });
    };

    handleChangeFormSearch = (searchAbstractProduct) => {
        this.searchAbstractProduct = {
            ...this.searchAbstractProduct,
            ...searchAbstractProduct,
        };
        this.pagingAbstractProduct();
    };

    handleSynchronizeSyncStore = () => {
        const searchObj = new BaseSearchObject();

        synchronizeAbstractProductService(searchObj)
            .then(({ data }) => {
                toast.success("Đồng bộ thành công");
            })
            .catch((error) => {
                console.error(error);
                toast.error("Đồng bộ dữ liệu có lỗi");
            });
        this.pagingAbstractProduct();
    };


    resetStore = () => {
        this.searchAbstractProduct = new BaseSearchObject();
        this.pageAbstractProduct = null;
        this.selectedAbstractProduct = new AbstractProductType();
        this.openAbstractProductCreateOrUpdate = false;
    };
}
